<router-outlet>
    <!-- componente pantalla (verdeclaro) -->
</router-outlet>
